import { render, staticRenderFns } from "./MobilePost.vue?vue&type=template&id=06908359"
import script from "./MobilePost.vue?vue&type=script&lang=js"
export * from "./MobilePost.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports